export default __webpack_public_path__ + "static/dont-overuse-images-7604f38cba7b466d90198bba83a7e7457704ed467d59a37285d90785ad937d5a.png";